import React from 'react';

const SignupButton = props => (
  <a
    href={`${process.env.GATSBY_APP_URL}/signup`}
    target="_blank"
    rel="noopener noreferrer"
    {...props}
  >
    Start Free Trial
  </a>
);

export default SignupButton;



// WEBPACK FOOTER //
// ./src/components/buttons/SignupButton.js